import { faArrowRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Card } from 'antd'
import React, { memo, useCallback, useState } from 'react'
import bloodTestImage from '../../../../../assets/Mobile app/Blood test.jpg'
import healthMonitoringImage from '../../../../../assets/Mobile app/Health monitoring.jpg'
import ivTherapyImage from '../../../../../assets/Mobile app/IV therapy.jpg'
import medDeliveryImage from '../../../../../assets/Mobile app/Med Delivery.jpg'
import '../styling/MobHealthcareConvenience.css'
import InfoSlider from './InfoSlider'

const MobHealthcareConvenience = memo(() => {
  const [selectedCard, setSelectedCard] = useState(null)

  const cards = [
    {
      id: 'medication',
      title: 'Meds to your door',
      description: 'Meta-Health joins forces with Dis-Chem',
      color: '#2E7D32', // Darker Green
      image: medDeliveryImage,
      fullDescription:
        'Get your medications delivered directly to your doorstep through our partnership with Dis-Chem. Enjoy automatic prescription refills, free delivery for qualifying orders, and real-time tracking of your medications.',
      features: [
        'Automatic prescription refills',
        'Free delivery for qualifying orders',
        'Real-time tracking',
        'Flexible delivery scheduling',
        'Secure payment options'
      ]
    },
    {
      id: 'blood-tests',
      title: 'Blood tests at a click',
      description: 'Our CareSync service for convenient testing.',
      color: '#0D47A1', // Darker Blue
      image: bloodTestImage,
      fullDescription:
        'Access convenient blood testing services through our CareSync program. Get your tests done at your preferred location with results delivered directly to your healthcare provider.',
      features: [
        'At-home sample collection',
        'Multiple testing locations',
        'Digital results delivery',
        'Secure data handling',
        'Insurance coverage support'
      ]
    },
    {
      id: 'iv-therapy',
      title: 'Replenish your temple',
      description: 'IV therapy service for optimal wellness.',
      color: '#6A1B9A', // Darker Purple
      image: ivTherapyImage,
      fullDescription:
        'Experience the benefits of IV therapy for optimal wellness. Our specialized treatments help you maintain peak health and vitality.',
      features: [
        'Customized IV formulations',
        'Professional administration',
        'Comfortable treatment rooms',
        'Expert medical supervision',
        'Post-treatment care'
      ]
    },
    {
      id: 'health-monitoring',
      title: 'Health monitoring',
      description: 'Track your vitals and receive personalized insights.',
      color: '#C62828', // Darker Red
      image: healthMonitoringImage,
      fullDescription:
        'Stay on top of your health with our comprehensive monitoring system. Track vital signs and receive personalized insights to maintain optimal health.',
      features: [
        'Vital signs tracking',
        'Personalized health insights',
        'Regular health reports',
        'Alert system for abnormalities',
        'Healthcare provider integration'
      ]
    }
  ]

  const handleCardClick = useCallback((card) => {
    setSelectedCard(card)
  }, [])

  const handleCloseSlider = useCallback(() => {
    setSelectedCard(null)
  }, [])

  return (
    <div className='healthcare-convenience-container'>
      <h2
        style={{
          textAlign: 'left',
          fontSize: 18,
          color: '#000000',
          fontWeight: 500,
          margin: '0 0 16px 0',
          padding: '0 0 0 4px'
        }}
      >
        Healthcare convenience
      </h2>

      <div className='convenience-carousel'>
        <div className='convenience-cards'>
          {cards.map((card) => (
            <div
              key={card.id}
              className='card-wrapper'
              style={{ width: '55%', minWidth: 160, marginRight: 10, flexShrink: 0 }}
              onClick={() => handleCardClick(card)}
              role='button'
              tabIndex={0}
              onKeyPress={(e) => e.key === 'Enter' && handleCardClick(card)}
              aria-label={`Learn more about ${card.title}`}
            >
              <Card
                className='convenience-card'
                style={{
                  borderRadius: '12px',
                  overflow: 'hidden',
                  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
                  border: 'none',
                  width: '100%',
                  height: 120,
                  padding: 0,
                  marginBottom: 8
                }}
                bodyStyle={{ padding: 0 }}
              >
                <div
                  className='card-image-container'
                  style={{
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    overflow: 'hidden',
                    backgroundColor: '#f5f5f5'
                  }}
                >
                  {card.image ? (
                    <img
                      src={card.image}
                      alt={card.title}
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover'
                      }}
                    />
                  ) : (
                    <div
                      style={{
                        color: '#CCCCCC',
                        fontSize: 12,
                        fontStyle: 'italic'
                      }}
                    >
                      Image coming soon
                    </div>
                  )}
                </div>
              </Card>
              <div className='card-text-content'>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginBottom: 4
                  }}
                >
                  <h3
                    style={{
                      fontSize: 15,
                      fontWeight: 600,
                      marginTop: 0,
                      marginBottom: 0,
                      marginRight: 4,
                      color: card.color
                    }}
                  >
                    {card.title}
                  </h3>
                  <FontAwesomeIcon
                    icon={faArrowRight}
                    style={{
                      fontSize: 10,
                      color: card.color
                    }}
                  />
                </div>
                <p
                  style={{
                    fontSize: 12,
                    color: '#444444',
                    lineHeight: 1.3,
                    margin: 0
                  }}
                >
                  {card.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <InfoSlider
        isOpen={!!selectedCard}
        onClose={handleCloseSlider}
        title={selectedCard?.title || ''}
        description={selectedCard?.fullDescription || ''}
        features={selectedCard?.features || []}
      />
    </div>
  )
})

MobHealthcareConvenience.displayName = 'MobHealthcareConvenience'

export default MobHealthcareConvenience
